<style lang="scss" scoped>
  .card-table tr:first-child td,
  .card-table tr:first-child th {
    border-top: 0;
  }

  .table th,
  .text-wrap table th {
    color: #9aa0ac;
    text-transform: uppercase;
    font-weight: 400;
  }

  .table th,
  .table td,
  .text-wrap table th,
  .text-wrap table td {
    padding: 0.75rem;
  }

  .table-vcenter td,
  .table-vcenter th {
    vertical-align: middle;
  }

  .value {
    font-size: 13px;
    font-weight: 600;
  }

  .first {
    min-height: 1.5rem;
  }

  .device-profile-image img {
    border-radius: 50%;
  }

  .status-icon {
    content: '';
    width: 0.5rem;
    height: 0.5rem;
    display: inline-block;
    background: currentColor;
    border-radius: 50%;
    -webkit-transform: translateY(-1px);
    transform: translateY(-1px);
    margin-right: 0.375rem;
    vertical-align: middle;
  }

  .progress-xs,
  .progress-xs .progress-bar {
    height: 0.25rem;
  }

  .dropdown {
    display: inline-block;
  }

  .dropdown-menu {
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
    min-width: 12rem;
  }

  .dropdown-item {
    display: block;
    width: 100%;
    padding: 0.25rem 1.5rem;
    clear: both;
    font-weight: 400;
    color: #6e7687;
    text-align: inherit;
    white-space: nowrap;
    background-color: transparent;
    border: 0;
  }

  .btn {
    cursor: pointer;
    color: #707478 !important;
    font-weight: 600;
    letter-spacing: 0.03em;
    font-size: 0.8125rem;
    min-width: 2.375rem;
  }
</style>

<template>
  <table class="table card-table table-vcenter text-nowrap">
    <thead>
      <tr>
        <th>{{ __('Dispositivo') }}</th>
        <th />
        <th>{{ __('Status') }}</th>
        <th>{{ __('Plano') }}</th>
        <th>{{ __('Estatística') }}</th>
        <th class="d-none d-lg-table-cell">
          {{ __('Faturamento') }}
        </th>
        <th />
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="device in devices"
        v-if="device.identifier"
      >
        <td
          class="pr-0"
          v-if="show(device)"
        >
          <div class="device-profile-image">
            <img
              width="60"
              :src="imageProfile(device)"
            >
          </div>
        </td>
        <td v-if="show(device)">
          <div class="text-wrap first value">
            <span
              class="status-icon bg-success"
              v-b-tooltip="status.device[device.status]"
              v-if="isActive(device.status)"
            />
            <span
              class="status-icon bg-dark"
              v-b-tooltip="status.device[device.status]"
              v-else-if="isDisabled(device.status)"
            />
            <span
              class="status-icon bg-danger"
              v-b-tooltip="status.device[device.status]"
              v-else
            />
            {{ device.alias }}
          </div>
          <div
            class="text-muted"
            v-if="device.phone"
          >
            {{ phoneFormat(device.phone) }}
            <a
              class="pointer ml-1"
              v-b-tooltip.bottom="'Autorizar um novo número Whatsapp. Mensagens aguardando para serem enviadas poderão ser enviadas pelo novo número.'"
              @click.prevent="authorize(device)"
              v-if="! isDisabled(device.status)"
            >
              <i class="fa fa-pencil-square-o ml-2" />
            </a>
          </div>
        </td>
        <td v-if="show(device)">
          <div class="first value">
            <span v-if="device.refreshing">
              <span
                class="status-icon bg-secondary"
                v-b-tooltip="'Atualizando dispositivo.'"
              />
              Atualizando
              <div class="float-right">
                <i class="fa fa-circle-o-notch fa-spin" />
              </div>
            </span>
            <span v-else-if="isDisabled(device.status)">
              <span class="status-icon bg-dark" />
              {{ status.billing[billing(device).status] }}
            </span>
            <span v-else-if="session(device).status === 'online'">
              <span
                class="status-icon bg-success"
                :v-b-tooltip="__('Dispositivo autorizado, é possível entregar mensagens.')"
              />
              Online
            </span>
            <span v-else>
              <span
                class="status-icon bg-danger"
                :v-b-tooltip="__('Dispositivo não autorizado, não é possível entregar mensagens.')"
              />
              <span
                class="pointer"
                :v-b-tooltip="__('Ler QrCode para autorizar dispositivo.')"
                @click.prevent="authorize(device)"
              >
                <span v-if="session(device).status.includes('authori')">{{ __('Não autorizado') }}</span>
                <span v-if="session(device).status.includes('offline')">Offline</span>
                <span v-if="session(device).status === 'timeout_sync'">{{ __('Tempo de sincronização excedido') }}</span>
                <span v-if="session(device).status === 'timeout'">{{ __('Tempo de conexão excedido') }}</span>
                <span v-if="session(device).status === 'conflict'">{{ __('Conflito de sessão') }}</span>
                <span v-if="session(device).status === 'blocked'">{{ __('Sessão bloqueada') }}</span>
                <span v-if="session(device).status === 'error'">{{ __('Erro') }}</span>
                <span v-if="session(device).status === 'new'">{{ __('Novo') }}</span>
              </span>
            </span>
          </div>
          <div class="text-muted">
            Sincronizado {{ session(device).lastSyncAt | ago }}
          </div>
        </td>
        <td v-if="show(device)">
          <div class="first value">
            <span
              class="status-icon bg-success"
              v-b-tooltip="status.billing[billing(device).status]"
              v-if="billing(device).status === 'active'"
            />
            <span
              class="status-icon bg-dark"
              v-b-tooltip="status.billing[billing(device).status]"
              v-else-if="billing(device).status === 'disabled'"
            />
            <span
              class="status-icon bg-danger"
              v-b-tooltip="status.billing[billing(device).status]"
              v-else
            />
            {{ plan(device).name }}
          </div>
          <div class="text-muted">
            Criado {{ billing(device).startedAt | ago }}
          </div>
        </td>
        <td v-if="show(device)">
          <div class="text-wrap first value">
            Enviadas: {{ billing(device).usage.textMessages }} / {{ limitText(device) }} mensagens
          </div>
          <div class="text-muted">
            Falha no envio: {{ billing(device).usage.failedMessages }}
          </div>
        </td>
        <td
          class="d-none d-lg-table-cell"
          v-if="show(device)"
        >
          <div
            class="clearfix"
            v-if="isDisabled(device.status)"
          >
            <div class="value float-left">
              {{ status.billing[billing(device).status] }}
            </div>
          </div>
          <div
            class="clearfix"
            v-else
          >
            <div class="value float-left">
              {{ progress(device) }}%
            </div>
            <div class="value float-right">
              <small class="text-muted">
                {{ billing(device).startsAt | datetime('DD-MMMM') }}
                a
                {{ billing(device).endsAt | datetime('DD-MMMM') }}
              </small>
            </div>
          </div>
          <div class="progress progress-xs">
            <div
              class="progress-bar bg-green"
              role="progressbar"
              :aria-valuenow="progress(device)"
              aria-valuemin="0"
              aria-valuemax="100"
              :style="'width: ' + progress(device) + '%;'"
            />
          </div>
        </td>
        <td
          class="text-center"
          v-if="show(device)"
        >
          <div class="dropdown">
            <button
              class="btn btn-box dropdown-toggle"
              type="button"
              id="dropdownMenuAction"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              Ações
            </button>
            <div
              class="dropdown-menu dropdown-menu-right"
              aria-labelledby="dropdownMenuAction"
            >
              <a
                class="btn dropdown-item"
                @click.prevent="refresh(device)"
                v-if="! isDisabled(device.status)"
              >
                <i class="fa fa-repeat mr-2" />{{ __('Atualizar status') }}
              </a>
              <a
                class="btn dropdown-item"
                @click.prevent="authorize(device)"
                v-if="! isDisabled(device.status)"
              >
                <i class="fa fa-qrcode mr-2" />{{ __('Autorizar') }}
              </a>
              <a class="btn dropdown-item d-none">
                <i class="fa fa-refresh mr-2" />{{ __('Sincronizar') }}
              </a>
              <a class="btn dropdown-item d-none">
                <i class="fa fa-power-off mr-2" />Reset session
              </a>
              <a class="btn dropdown-item d-none">
                <i class="fa fa-file-text-o mr-2" />{{ __('Alterar plano') }}
              </a>
              <a
                class="btn dropdown-item"
                @click.prevent="destroy(device)"
              >
                <i class="fa fa-trash-o mr-2" />{{ __('Excluir') }}
              </a>
              <span v-if="root">
                <a
                  class="btn dropdown-item"
                  @click.prevent="enable(device)"
                  v-if="isDisabled(device.status)"
                >
                  <i class="fa fa-toggle-on mr-2" />{{ __('Habilitar') }}
                </a>
                <a
                  class="btn dropdown-item"
                  @click.prevent="enable(device, false)"
                  v-else
                >
                  <i class="fa fa-toggle-off mr-2" />{{ __('Desabilitar') }}
                </a>
              </span>
            </div>
          </div>
        </td>
      </tr>
      <tr v-else>
        <td
          class="first value"
          colspan="6"
        >
          {{ __('Há uma solicitação em andamento. Aguarde a confirmação do pagamento para prosseguir com a ativação') }}.
        </td>
        <td class="text-center">
          <div class="dropdown">
            <button
              class="btn btn-box dropdown-toggle"
              type="button"
              id="dropdownMenuAction"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              Ações
            </button>
            <div
              class="dropdown-menu dropdown-menu-right"
              aria-labelledby="dropdownMenuAction"
            >
              <a
                class="btn dropdown-item"
                @click.prevent="invoice(device)"
              >
                <i class="fa fa-dollar mr-2" />{{ __('Visualizar fatura') }}
              </a>
              <a
                class="btn dropdown-item d-none"
                @click.prevent="duplicate(device)"
              >
                <i class="fa fa-files-o mr-2" />{{ __('Segunda via') }}
              </a>
              <a class="btn dropdown-item d-none">
                <i class="fa fa-file-text-o mr-2" />{{ __('Alterar plano') }}
              </a>
              <a
                class="btn dropdown-item"
                @click.prevent="destroy(device)"
              >
                <i class="fa fa-trash-o mr-2" />{{ __('Excluir') }}
              </a>
            </div>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { VBTooltip } from 'bootstrap-vue';
import imageProfileIfNull from './imageProfileIfNull.json';
import dayjs from '../../../core/dayjs';
import { Confirm } from '../../../services/Confirm';

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },

  props: {
    plans: {
      required: true,
    },
    devices: {
      required: true,
    },
    root: {
      type: Boolean,
      default: false,
    },
  },

  mounted () {
    Bus.$on('refreshDevice', (device) => {
      this.refresh(device);
    });
  },

  data () {
    return {
      status: {
        device: {
          banned: this.__('Banido'),
          invalid: this.__('Inválido'),
          removed: this.__('Removido'),
          pending: this.__('Pendente'),
          verified: this.__('Verificado'),
          operative: this.__('Operativo'),
          authorized: this.__('Autorizado'),
          disabled: this.__('Desabilitado'),
        },
        billing: {
          active: this.__('Ativo'),
          past_due: this.__('Vencido'),
          unpaid: this.__('Falta pagar'),
          disabled: this.__('Desativado'),
          cancelled: this.__('Cancelado'),
        },
      },
    };
  },

  methods: {
    isActive (status) {
      return ['authorized', 'verified', 'operative'].indexOf(status) !== -1;
    },

    isDisabled (status) {
      return status == 40 || status === 'disabled';
    },

    phoneFormat (phone) {
      return `(${phone.slice(3, 5)}) ${phone.slice(5, -4)}-${phone.slice(-4)}`;
    },

    show (device) {
      if (this.isDisabled(device.status)) {
        return this.root === true;
      }

      return true;
    },

    billing (device) {
      return device.metadata.wassenger.billing;
    },

    session (device) {
      return device.metadata.wassenger.session;
    },

    imageProfile (device) {
      const imageProfile = device.metadata.wassenger.imageProfile || imageProfileIfNull.imageProfile;

      return `data:image/png;base64,${imageProfile}`;
    },

    plan (device) {
      const name = this.billing(device).planCode;

      return this.plans.find((plan) => [name, `gateway-${name}`].indexOf(plan.plan) > -1);
    },

    limitText (device) {
      return this.plan(device).limits.text >= 0 ? this.plan(device).limits.text : 'ilimitadas';
    },

    progress (device) {
      const startsAt = dayjs(this.billing(device).startsAt);
      const endsAt = dayjs(this.billing(device).endsAt);

      return Math.trunc(dayjs().diff(startsAt, 'days') / endsAt.diff(startsAt, 'days') * 100);
    },

    async authorize (device) {
      device.force = false;

      if (this.session(device).status === 'online') {
        if (! await Confirm(`${this.__('Este dispositivo está online.')}\n${this.__('Deseja continuar mesmo assim?')}`)) {
          this.refresh(device);

          return;
        }

        device.force = true;
      }

      Bus.$emit('authorizingScanDevice', device);
      Bus.$emit('scanningButtonToggle');
    },

    refresh (device) {
      const index = this.devices.indexOf(device);

      device.refreshing = true;
      this.devices.splice(index, 1, device);

      this.$http.post('/device/refresh', device)
        .then(({ data: device }) => {
          this.devices.splice(index, 1, device);
        })
        .catch(({ data: error }) => {
          console.log(`${error.status}: ${error.message}`);

          Alert.error(this.__('Erro na atualização.'));

          device.refreshing = false;
          this.devices.splice(index, 1, device);
        });
    },

    enable (device, enable = true) {
      const index = this.devices.indexOf(device);

      device.refreshing = true;
      this.devices.splice(index, 1, device);

      device.update = { enable };

      this.$http.patch('/device', device)
        .then(({ data: device }) => {
          this.devices.splice(index, 1, device);
        })
        .catch(({ data: error }) => {
          console.log(`${error.status}: ${error.message}`);

          Alert.error(this.__('Erro na atualização.'));

          device.refreshing = false;
          this.devices.splice(index, 1, device);
        });
    },

    invoice (device) {
      Bus.$emit('tenantInvoice', device.metadata.invoice);
    },

    async destroy (device) {
      const title = this.__('Deseja mesmo excluir este dispositivo?');
      const text = this.__('Esta ação não poderá ser desfeita!');

      if (! await Confirm(title, text)) {
        return;
      }

      const params = {
        identifier: device.identifier,
      };

      this.$http.delete('/device', { body: params })
        .then((response) => {
          Alert.success(this.__('Dispositivo excluído.'));

          this.devices.splice(this.devices.indexOf(device), 1);
        })
        .catch(() => {
          Alert.error(this.__('Erro ao excluir dispositivo'));
        });
    },
  },
};
</script>
